import { Stack, Typography } from '@mui/material';
import React from 'react';
import { variants } from '../../../variants/variants';
import empty from '../../../assets/empty.png';
const NoComments = () => {
  return (
    <Stack alignItems={'center'} justifyContent={'center'} sx={{ p: 2, mt: 2, height: '100%' }}>
      <img style={{ width: '60%' }} src={empty} alt='pending' />
      <Typography sx={{ fontSize: variants.TINY, p: 1, color: 'rgba(0,0,0,0.7)' }}>No comments available!</Typography>
    </Stack>
  );
};

export default NoComments;
